import { render } from "./AssignedAssets.vue?vue&type=template&id=1fb641e9"
import script from "./AssignedAssets.vue?vue&type=script&lang=js"
export * from "./AssignedAssets.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__